import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { updateSecondaryFilter, selectSecondaryFilter } from './secondaryFilterSlice';
import translate from '../../utilities/translator';
import { scrollToResults } from '../../utilities/helpers';
import { pushEvent } from '../../utilities/analytics';
import { SORT_BY_EVENT, SEC_FILTER_OPEN } from '../../constants/analyticEvents';
import { clearPrefetchDeals } from '../dealsList/prefetchDealsSlice';

export default function Sort({ isOpen, setIsOpen }) {
  const dispatch = useDispatch();
  const { data } = useSelector(selectSecondaryFilter);
  const { sort } = data;
  const ref = useRef();
  const activeSort = sort.find(({ active }) => active);

  const updateFilter = (index) => {
    const updatedSort = sort.map((item, i) => ({
      ...item,
      active: index === i,
    }));

    dispatch(clearPrefetchDeals());
    dispatch(updateSecondaryFilter({ updatedValue: updatedSort, filter: 'sort' }));
    pushEvent(
      SORT_BY_EVENT,
      updatedSort.find(({ active }) => active)
    );
    setIsOpen(false);
    scrollToResults();
  };

  const openSort = (st) => {
    if (!isOpen) {
      pushEvent(SEC_FILTER_OPEN, { filterName: 'sort' });
    }
    setIsOpen(st);
  };

  useOnClickOutside(ref, () => isOpen && setIsOpen(false));

  return (
    <div className={`sort ${isOpen ? 'sort_open' : ''} `} ref={ref}>
      <div className="sort__wrap" role="button" tabIndex={0} onClick={() => openSort(!isOpen)}>
        <span className="mobileOnly">{translate('holidayFinder.secondaryFilter.Sort_by')}</span>{' '}
        <span data-label={activeSort.label}>
          {(activeSort.label === 'cheapest_per_destination') ?
            translate('holidayFinder.secondaryFilter.sort_price') :
            translate(`holidayFinder.secondaryFilter.sort_${activeSort.label}`)
          }
          <i className="ri-arrow-down-s-line chevron" />
        </span>
      </div>
      {isOpen && (
        <div className="sort__body">
          {sort.map(({ label, active }, i) => (
            <button className={active ? 'active' : ''} type="button" onClick={() => updateFilter(i)} key={label}>
              {translate(`holidayFinder.secondaryFilter.sort_${label}`)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

Sort.propTypes = {
  children: PropTypes.node,
};
